import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router';
import IMCRazorPayicon from '../../assets/RazorPay.png';

const useStyles = makeStyles((theme) => ({
    imcCard: {
        background: '#63637d',
        minHeight: '150px',
        borderRadius: '6px',
        color: '#ffffff',
        fontFamily: 'Rubik',
        padding: '30px',
    },
    imcCardTitle: {
        fontSize: '16px',
    },
    imcCardImg: {
        width: '50%',
        '& img': {
            margin: '30px 0 10px',
            height: '60px',
        },
    },
    imcCardMore: {
        fontSize: '12px',
        fontWeight: '100',
        cursor: 'pointer',
    },
}));

export default function AdminRazorPay() {
    const classes = useStyles();
    const history = useHistory();

    const navigate = () => {
        history.push('/menu/view-razorpay');
    };

    return (
        <div className={classes.imcCard}>
            <div className={classes.imcCardTitle}>
                RazorPay
                <br />
                <br />
            </div>
            <div className={classes.imcCardImg}>
                <img src={IMCRazorPayicon} alt="razorpay" />
            </div>
            <div className={classes.imcCardMore} onClick={navigate}>
                More <FontAwesomeIcon style={{ fontSize: '11px' }} icon={faLongArrowAltRight} />
            </div>
        </div>
    );
}
